import { render } from "./MusubiSectorSelect.vue?vue&type=template&id=67f14272&scoped=true"
import script from "./MusubiSectorSelect.vue?vue&type=script&lang=js"
export * from "./MusubiSectorSelect.vue?vue&type=script&lang=js"

import "./MusubiSectorSelect.vue?vue&type=style&index=0&id=67f14272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f14272"]])

export default __exports__